<template>
  <div class="container">
    <a-divider type="horizontal" class="divider" />

    <a-popover
      v-model:open="visible"
      :title="null"
      placement="right"
      overlayClassName="email-template-item-input__popover"
    >
      <template #content>
        <a-tooltip
          :title="isFooter ? 'No se puede agrega un elemento' : 'Agregar elemento'"
          placement="right"
        >
          <a-button
            class="button"
            type="link"
            @click="handleAdd"
            :disabled="isFooter || isHtmlTemplate"
          >
            <PlusOutlined class="button__icon" />
          </a-button>
        </a-tooltip>

        <a-tooltip title="Editar elemento" placement="right">
          <a-button class="button" type="link" @click="handleSettings">
            <SettingOutlined class="button__icon" />
          </a-button>
        </a-tooltip>

        <a-tooltip
          :title="isFooter ? 'Elemento no duplicable' : 'Duplicar elemento'"
          placement="right"
        >
          <a-button
            class="button"
            type="link"
            @click="handleCopy"
            :disabled="isFooter || isHtmlTemplate"
          >
            <CopyOutlined class="button__icon" />
          </a-button>
        </a-tooltip>

        <a-tooltip
          :title="isFooter ? 'Elemento obligatorio' : 'Eliminar elemento'"
          placement="right"
        >
          <a-button
            class="button"
            type="link"
            @click="handleDelete"
            :disabled="isFooter || isHtmlTemplate"
          >
            <DeleteOutlined class="button__icon" />
          </a-button>
        </a-tooltip>
      </template>

      <div class="card__container">
        <div id="drag-zone" class="drag__zone" :class="{ 'no-drag': isFooter }">
          <MoreOutlined class="drag__icon" />
          <MoreOutlined class="drag__icon" />
        </div>

        <div class="card" :class="{ select: selected }">
          <TemplateItemComponent :item="item" @htmlStringEdited="emit('htmlStringEdited')" />
        </div>
      </div>
    </a-popover>
  </div>
</template>

<script setup lang="ts">
import { ref, inject, watch, nextTick, computed } from "vue";
import type { Ref } from "vue";
import {
  MoreOutlined,
  PlusOutlined,
  SettingOutlined,
  CopyOutlined,
  DeleteOutlined,
} from "@ant-design/icons-vue";

import { ItemType, TemplateItem } from "@/@types/flows/emailTemplates/items";

import TemplateItemComponent from "@/app/flows/emailTemplates/components/sections/TemplateItem/index.vue";
import { TemplateType } from "@/@types/flows/emailTemplates";

const props = defineProps<{
  item: TemplateItem;
  selected: boolean;
  templateType: TemplateType;
}>();

const emit = defineEmits<{
  select: [input: TemplateItem | undefined];
  "click:add": [input: TemplateItem];
  "click:settings": [input: TemplateItem];
  "click:copy": [input: TemplateItem];
  "click:delete": [input: TemplateItem];
  htmlStringEdited: [];
}>();

const visible = ref(false);

const selectedItem = inject("selectedItem") as Ref<TemplateItem | undefined>;

// const disabledSettings = computed(() =>
//   [ElementType.Pdp, ElementType.Reminder].includes(props.input.type)
// );

// watch(visible, (isVisible) => {
//   const keepSelect = currentAction.value === "add" || currentAction.value === "settings";

//   if (isVisible) selectedItem.value = props.input;
//   else if (!keepSelect) selectedItem.value = undefined;
// });
const isFooter = computed(() => props.item.type === ItemType.Footer);
const isHtmlTemplate = computed(() => Number(props.templateType) === TemplateType.Html);

watch(visible, (isPopoverVisible) => {
  handleSelect(isPopoverVisible ? props.item : undefined);
});

const handleSelect = (item: TemplateItem | undefined) => {
  selectedItem.value = item;
};

const handleAdd = async () => {
  visible.value = false;
  emit("click:add", props.item);
  await nextTick();
  handleSelect(props.item);
};

const handleSettings = async () => {
  visible.value = false;
  emit("click:settings", props.item);
  await nextTick();
  handleSelect(props.item);
};

const handleCopy = () => {
  visible.value = false;
  emit("click:copy", props.item);
};

const handleDelete = async () => {
  visible.value = false;
  await nextTick();
  emit("click:delete", props.item);
  handleSelect(undefined);
};
</script>

<style scoped lang="sass">
.divider
  margin: 0
  margin-left: 30px
  color: $gray-4

.container
  // background-color: white

.card
  display: flex
  flex: 1 1 auto
  position: relative
  background-color: white
  border: 1px dashed transparent
  border-radius: 4px
  cursor: pointer
  transition: border-color 0.2s ease-out

  &__container
    display: flex
    gap: 14px
    align-items: center

  &:hover
    border-color: $blue-6

  &.select
    border-color: $blue-6

.input
  width: 100%
  pointer-events: none

.drag
  &__zone
    &.no-drag
      pointer-events: none
      opacity: 0

  &__icon
    font-size: 20px
    color: $gray-1

    &:last-child
      margin-left: -26px

.button
  padding: 0

  &__icon
    font-size: 16px
</style>

<style>
.email-template-item-input__popover .ant-popover-arrow {
  display: none;
}

.email-template-item-input__popover .ant-popover-content,
.email-template-item-input__popover .ant-popover-inner {
  border-radius: 4px;
  padding: 0;
}

.email-template-item-input__popover .ant-popover-inner-content {
  padding: 6px 10px !important;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
</style>
